export const customerConstants = {
    CREATE_SUCCESS: 'CUSTOMER_CREATE_SUCCESS',
    CREATE_FAILURE: 'CUSTOMER_CREATE_FAILURE',

    UPDATE_SUCCESS: 'CUSTOMER_UPDATE_SUCCESS',
    UPDATE_FAILURE: 'CUSTOMER_UPDATE_FAILURE',

    DELETE_SUCCESS: 'CUSTOMER_DELETE_SUCCESS',
    DELETE_FAILURE: 'CUSTOMER_DELETE_FAILURE',

    GET_ONE_SUCCESS: 'CUSTOMER_GET_ONE_SUCCESS',
    GET_ONE_FAILURE: 'CUSTOMER_GET_ONE_FAILURE',

    GET_ALL_SUCCESS: 'CUSTOMER_GET_ALL_SUCCESS',
    GET_ALL_FAILURE: 'CUSTOMER_GET_ALL_FAILURE',

    GET_GROUP_SUCCESS: 'CUSTOMER_GET_GROUP_SUCCESS',
    GET_GROUP_FAILURE: 'CUSTOMER_GET_GROUP_FAILURE',

    GET_UPDATE_GROUP_SUCCESS: 'CUSTOMER_UPDATE_GROUP_SUCCESS',
    GET_UPDATE_GROUP_FAILURE: 'CUSTOMER_UPDATE_GROUP_FAILURE',

    GET_DELETE_GROUP_SUCCESS: 'CUSTOMER_DELETE_GROUP_SUCCESS',
    GET_DELETE_GROUP_FAILURE: 'CUSTOMER_DELETE_GROUP_FAILURE',
};